import { render, staticRenderFns } from "./uppy_cars_entity_doc.vue?vue&type=template&id=6d68addb&scoped=true"
import script from "./uppy_cars_entity_doc.vue?vue&type=script&lang=js"
export * from "./uppy_cars_entity_doc.vue?vue&type=script&lang=js"
import style0 from "./uppy_cars_entity_doc.vue?vue&type=style&index=0&id=6d68addb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d68addb",
  null
  
)

export default component.exports